import React from 'react';
import { Header } from './components/Header';
import { Article } from './components/Article';
import { FacebookPixel } from './components/FacebookPixel';
import { ClarityAnalytics } from './components/ClarityAnalytics';
export function App() {
  return <div className="flex flex-col w-full min-h-full bg-white" data-id="element-0">
      <FacebookPixel data-id="element-1" />
      <ClarityAnalytics data-id="element-2" />
      <Header data-id="element-3" />
      <Article data-id="element-4" />
    </div>;
}